var video_viewer_default = {
  "video_player": "-bIQx",
  "videoOverlay": "ViGRq",
  "video_container": "YQh75"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
